export default __webpack_public_path__ + "static/media/incentives.0b69e327.jpg";